import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface SessionState {
  sessionId: string | null;
  setSessionId: (sessionId: string) => void;
  clearSession: () => void;
  clearslocalStorageSessionId: () => void;
}

export const useSessionStore = create<SessionState>()(
  persist(
    (set) => ({
      sessionId: null,
      setSessionId: (sessionId) => set({ sessionId }),
      clearSession: () => set({ sessionId: null }),
      clearslocalStorageSessionId: () => {
        localStorage.removeItem('sessionid');
        set({ sessionId: null });
      },
    }),
    {
      name: 'sessionid',
      storage: createJSONStorage(() => localStorage),
    }
  )
);